import React from "react";
import UnderConstruction from "../UnderConstruction";
import { hasRight, UserRight } from "../../core/models/User";
import useCubit from "../../blocs/hooks";
import { AuthState } from "../../blocs/auth/authStates";
import { AuthCubit } from "../../blocs/auth/AuthBloc";
import LoginButton from "../LoginButton";

interface WhoAreYouProps {
    children?: React.ReactNode;
    requiredUserRight: UserRight;
}

export const WhoAreYou: React.FC<WhoAreYouProps> = ({ children, requiredUserRight }) => {
    const authCubit = AuthCubit.getInstance();
    const authState: AuthState = useCubit(authCubit);
    // if the user isn't logged in we should show him the WhoAreYou design
    if (authState.state !== "LOGGEDIN") return <WhoAreYouQuestion />
    // okay now the user is logged int, if he has the required right then we show the child else we show him that he isn't supposed to be here
    if (hasRight(requiredUserRight, authState.user)) return <>{children ?? <UnderConstruction />}</>;
    // now we show him that he isn't supposed to be here
    return <IDontKnowWhatYoureTalkingAbout />
}

function WhoAreYouQuestion() {
    const gifs: Array<string> = [
        "https://c.tenor.com/MV4nCg2OxSMAAAAd/tenor.gif",
        "https://c.tenor.com/cfuCH-bxPYMAAAAd/tenor.gif",
        "https://c.tenor.com/OWJeVKInEs0AAAAd/tenor.gif",
        "https://c.tenor.com/qJtHltX59DAAAAAd/tenor.gif"
    ];
    const randomeGif = gifs[Math.floor(Math.random() * gifs.length)];
    return <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <h2>Who are you?</h2>
        <img
            src={randomeGif}
            alt="Who are you?"
            style={{ height: '300px', margin: '20px' }}
        />
        <LoginButton />
    </div>;
}

function IDontKnowWhatYoureTalkingAbout() {
    const authCubit = AuthCubit.getInstance();
    const authState: AuthState = useCubit(authCubit);
    const gifs: Array<string> = [
        "https://c.tenor.com/Dthke1L_20wAAAAd/tenor.gif",
        "https://c.tenor.com/pon4mccm_DwAAAAd/tenor.gif",
        "https://c.tenor.com/E5RQXxqiGSsAAAAd/tenor.gif",
        "https://c.tenor.com/FHtrekXvh6IAAAAd/tenor.gif"
    ];
    const randomeGif = gifs[Math.floor(Math.random() * gifs.length)];
    return <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <h2>I don't know what you're talking about {authState.user?.username ?? ""}</h2>
        <img
            src={randomeGif}
            alt="I don't know whare you're talking about"
            style={{ height: '300px', margin: '20px' }}
        />
    </div>;
}
